import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/cruiseTeam`
//#region 基本信息
const GetList = `${apiUrl}`
const Post = `${apiUrl}`
const Put = (id: number) => `${apiUrl}/${id}`
const Get = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
const PostMembers = (id: number) => `${apiUrl}/members/submit/${id}`
const DeleteMember = (id: number) => `${apiUrl}/member/delete/${id}`
//巡防组织下的巡查人员
const GetMembers = (teamId: number) => `${apiUrl}/members/${teamId}`
//可以添加的巡查人员
const SearchMembers = `${apiUrl}/members/search`
//#endregion

export const emptyCruiseTeam: CruiseTeamData = {
    Id: 0,
    ItemCode: '',
    ItemValue: '',
    Comments: '',
    SubSequence: 0,

    UserIds: []
}
export interface CruiseTeamData {
    [key: string]: any
    Id: number
    ItemCode: string
    ItemValue: string
    Comments: string
    SubSequence: number

    UserIds: number[]
}
export const searchMembers = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: SearchMembers,
        params: param
    })
}
export const getMembers = (teamId: number) => {
    return tryAxios({
        method: 'get',
        url: GetMembers(teamId)
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}

export const postMembers = (teamId: number, form: any) => {
    return tryAxios({
        method: 'post',
        url: PostMembers(teamId),
        data: form
    })
}
export const deleteMember = (id: number) => {
    return tryAxios({
        method: 'post',
        url: DeleteMember(id)
    })
}

export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}

export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}

export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}

export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}
